import { useState } from "react";
import { HintsLink } from "../../../modules/hints/components/HintsLink";
import { HintsAccordionItem } from "../../../modules/hints/components/HintsAccordionItem";

const HintsAndTips = ({ lang }: { lang: string }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (lang === "de") {
    return (
      <div className="min-h-full text-foreground gap-4 flex flex-col text-base">
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center mb-6">
          Hinweise und Tipps
        </h1>
        <div className="flex flex-col">
          <HintsAccordionItem
            onToggle={() => toggle(0)}
            isOpen={openIndex === 0}
            header="SUP Board"
          >
            <p>
              Das SUP Board ist eine großartige Möglichkeit, um die Schönheit
              der Natur vom Wasser aus zu erleben. Es bietet eine einzigartige
              Perspektive und ermöglicht es Ihnen, die Umgebung aus einer neuen
              Sicht zu genießen.
            </p>
            <HintsLink
              href="https://www.youtube.com/watch?v=5ujfIHwsLDs"
              target="_blank"
              className="block mt-2"
              rel="noopener noreferrer"
            >
              SUP Board YouTube Video
            </HintsLink>
          </HintsAccordionItem>
        </div>
      </div>
    );
  } else {
    return (
      <div className="min-h-full text-foreground gap-4 flex flex-col text-base">
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center mb-6">
          Hints and Tips
        </h1>
        <div className="flex flex-col">
          <HintsAccordionItem
            onToggle={() => toggle(0)}
            isOpen={openIndex === 0}
            header="SUP Board"
          >
            <p>
              The SUP board is a great way to experience the beauty of nature
              from the water. It offers a unique perspective and allows you to
              enjoy the surroundings from a new perspective.
            </p>
            <HintsLink
              href="https://www.youtube.com/watch?v=5ujfIHwsLDs"
              target="_blank"
              className="block mt-2"
              rel="noopener noreferrer"
            >
              SUP Board YouTube Video
            </HintsLink>
          </HintsAccordionItem>
        </div>
      </div>
    );
  }
};

export default HintsAndTips;
